// ============================================================
// CalendarSkeleton.tsx
// Loading placeholders for the calendar grids (month cells, the time-grid's
// all-day strip + hour columns) and the fade rule for revealed items.
//
// Tokens only: the bar is casevo-border at 60% — a soft green-grey on the light
// diary (#c8ddd0 over the off-white ground) and a lifted forest tint on the
// dark one (#3c4d43 over #16221b), so it reads in light, dark and the
// calendar's own `.casevo-light` / `dark` focus scope alike. The pulse stops
// for reduced motion (motion-reduce:animate-none). Purely decorative →
// aria-hidden; the grids announce "Loading calendar…" once via role=status.
// ============================================================
import React from 'react'

// Which items fade in when they mount:
//  'all'     — a range just revealed from the skeleton (everything together)
//  'outlook' — shown from the cache, Outlook arriving late (only Outlook fades)
//  'none'    — shown from the cache (instant, no animation)
export type CalendarFade = 'all' | 'outlook' | 'none'

export const fadeClassFor = (fade: CalendarFade, isOutlook: boolean): string =>
  fade === 'all' || (isOutlook && fade === 'outlook') ? ' animate-fade-in motion-reduce:animate-none' : ''

export const SkeletonBar: React.FC<{ className?: string; style?: React.CSSProperties }> = ({ className = '', style }) => (
  <span
    aria-hidden="true"
    data-testid="calendar-skeleton"
    style={style}
    className={`block rounded-[3px] bg-casevo-border/60 animate-pulse motion-reduce:animate-none ${className}`}
  />
)
